import { CallZone, callZones } from "@/app/CallbackLeads/Utils/callZones";
import { MultiSelectFilter } from "@/lib/Components/DataTable/Filters/MultiSelectFilter";
import { useTranslations } from "use-intl";

export function CallZoneFilter({
  selected,
  onChange,
}: {
  selected: CallZone[];
  onChange: (newZones: CallZone[]) => void;
}) {
  const t = useTranslations("callbackLead");

  const options = callZones.map((zone) => ({
    label: t(`zone.${zone}`),
    value: zone,
  }));

  return (
    <MultiSelectFilter
      label={t("filters.zone")}
      options={options}
      selected={selected}
      onChange={onChange}
    />
  );
}
